/**
 * FlatReklam — Shopify Horizon agentic browsing (PSI agent-accessibility-tree)
 * v5: PDP media-gallery slide'larına display:none uygulanmaz (thumbnail tıklama düzeltmesi)
 */
(function () {
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'

  var CARD_HIDDEN_SLIDES =
    'product-card slideshow-slide[aria-hidden="true"], .card-gallery slideshow-slide[aria-hidden="true"], [aria-hidden="true"].resource-list__slide'

  var PDP_HIDDEN_SLIDES = 'media-gallery slideshow-slide[aria-hidden="true"]'

  function inMediaGallery(el) {
    return !!(el && el.closest && el.closest('media-gallery'))
  }

  function storeTabindex(el) {
    if (el.dataset.frkTabindexStored) return
    el.dataset.frkTabindexStored = '1'
    el.dataset.frkTabindex = el.getAttribute('tabindex') == null ? '' : String(el.getAttribute('tabindex'))
  }

  function disableFocusableInHidden(root) {
    if (root.getAttribute && root.getAttribute('aria-hidden') === 'true') {
      storeTabindex(root)
      root.setAttribute('tabindex', '-1')
    }
    if (root.matches && root.matches(FOCUSABLE)) {
      storeTabindex(root)
      root.setAttribute('tabindex', '-1')
    }
    root.querySelectorAll(FOCUSABLE).forEach(function (el) {
      storeTabindex(el)
      el.setAttribute('tabindex', '-1')
    })
    if ('inert' in HTMLElement.prototype) {
      try {
        root.inert = true
      } catch (e) {
        /* ignore */
      }
    }
  }

  function enableFocusableInVisible(root) {
    if ('inert' in HTMLElement.prototype) {
      try {
        root.inert = false
      } catch (e) {
        /* ignore */
      }
    }
    var nodes = root.querySelectorAll ? root.querySelectorAll('[data-frk-tabindex-stored]') : []
    if (root.dataset && root.dataset.frkTabindexStored) nodes = [root].concat(Array.prototype.slice.call(nodes))
    nodes.forEach(function (el) {
      var saved = el.dataset.frkTabindex
      if (saved === '') el.removeAttribute('tabindex')
      else el.setAttribute('tabindex', saved)
      delete el.dataset.frkTabindexStored
      delete el.dataset.frkTabindex
    })
  }

  function fixAriaHiddenSlides() {
    document.querySelectorAll(CARD_HIDDEN_SLIDES).forEach(disableFocusableInHidden)
    document.querySelectorAll(PDP_HIDDEN_SLIDES).forEach(disableFocusableInHidden)

    document.querySelectorAll('slideshow-slide, .resource-list__slide').forEach(function (slide) {
      if (slide.getAttribute('aria-hidden') === 'true') return
      enableFocusableInVisible(slide)
    })
  }

  /** Horizon ürün kartı: product-card__link + card-gallery a.contents çift link */
  function fixProductCardDualLinks() {
    document.querySelectorAll('product-card').forEach(function (card) {
      var overlay = card.querySelector(':scope > a.product-card__link[href]')
      if (!overlay) return
      card.querySelectorAll('.card-gallery a.contents[href]').forEach(function (galleryLink) {
        if (galleryLink.dataset.frkGalleryNeutralized) return
        galleryLink.dataset.frkGalleryNeutralized = '1'
        storeTabindex(galleryLink)
        galleryLink.setAttribute('tabindex', '-1')
        if (galleryLink.getAttribute('href')) {
          galleryLink.dataset.frkHref = galleryLink.getAttribute('href')
          galleryLink.removeAttribute('href')
        }
      })
    })
  }

  /** Carousel modunda aria-hidden slayt içindeki product-card linkleri (PDP media-gallery hariç) */
  function fixLinksInsideHiddenSlides() {
    document.querySelectorAll('[aria-hidden="true"] ' + FOCUSABLE).forEach(function (el) {
      if (inMediaGallery(el)) return
      storeTabindex(el)
      el.setAttribute('tabindex', '-1')
      if (el.tagName === 'A' && el.getAttribute('href')) {
        if (!el.dataset.frkHref) el.dataset.frkHref = el.getAttribute('href')
        el.removeAttribute('href')
      }
    })
  }

  function labelUnnamedLinks() {
    document.querySelectorAll('a.content-over-media, a[class*="content-over-media"]').forEach(function (anchor) {
      if (anchor.getAttribute('aria-label')?.trim() || anchor.textContent?.trim()) return
      var img = anchor.querySelector('img[alt]')
      var alt = img?.getAttribute('alt')?.trim()
      if (alt) anchor.setAttribute('aria-label', alt)
      else if (anchor.getAttribute('href')) {
        var slug = (anchor.getAttribute('href') || '').split('/').filter(Boolean).pop() || 'page'
        anchor.setAttribute('aria-label', slug.replace(/-/g, ' '))
      }
    })

    document.querySelectorAll('a.tap-area, button.tap-area, a.product-card__link').forEach(function (el) {
      if (el.getAttribute('aria-label')?.trim() || el.textContent?.trim()) return
      var controls = el.getAttribute('aria-controls') || ''
      if (controls.includes('search')) el.setAttribute('aria-label', 'Search')
      else if (controls.includes('cart')) el.setAttribute('aria-label', 'Cart')
      else if (controls.includes('menu')) el.setAttribute('aria-label', 'Open menu')
      else if (el.classList.contains('product-card__link')) {
        var hidden = el.closest('[aria-hidden="true"]')
        if (!hidden) {
          var title = el.querySelector('.visually-hidden')?.textContent?.trim()
          if (title) el.setAttribute('aria-label', title)
        }
      }
    })

    document.querySelectorAll('button[is="prev-button"], .slideshow-control--previous').forEach(function (btn) {
      if (!btn.getAttribute('aria-label')?.trim()) btn.setAttribute('aria-label', 'Previous slide')
    })
    document.querySelectorAll('button[is="next-button"], .slideshow-control--next').forEach(function (btn) {
      if (!btn.getAttribute('aria-label')?.trim()) btn.setAttribute('aria-label', 'Next slide')
    })
  }

  function run() {
    fixAriaHiddenSlides()
    fixProductCardDualLinks()
    fixLinksInsideHiddenSlides()
    labelUnnamedLinks()
  }

  run()

  var scheduled = false
  function scheduleRun() {
    if (scheduled) return
    scheduled = true
    requestAnimationFrame(function () {
      scheduled = false
      run()
    })
  }

  if (typeof MutationObserver !== 'undefined' && document.documentElement) {
    new MutationObserver(scheduleRun).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'tabindex', 'href'],
      subtree: true,
      childList: true,
    })
  }

  document.addEventListener('DOMContentLoaded', run)
  window.addEventListener('load', run)
  document.addEventListener('shopify:section:load', run)

  ;[0, 50, 150, 400, 1000, 2500].forEach(function (ms) {
    setTimeout(run, ms)
  })
})()
